export class AddQuestion{
    static readonly type='[Question] es muss ein Typ User Objekt zur Liste hinzugefügt werden';
    constructor(public payload: any){}
}
